import { departmentDashboard } from '../../actions/constant';

const {
   GET_SUPERVISOR_ALERT_REQUEST,
  GET_SUPERVISOR_ALERT_SUCCESS,
  GET_SUPERVISOR_ALERT_FAILURE,
  GET_SUPERVISOR_ALERT_LOADING,
  GET_SUPERVISOR_ALERT_RESET,
} = departmentDashboard;

const intitialstate: object = {
  response: null,
  isAlert: false,
  errorMessage: '',
  loading: false,
};

export const getSupervisoryAlertReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_SUPERVISOR_ALERT_SUCCESS: {
      return {
        ...state,
        isAlert: true,
        response: action.payload.data,
        loading: false,
      };
    }

    case GET_SUPERVISOR_ALERT_FAILURE:
      return {
        ...state,
        isAlert: false,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_SUPERVISOR_ALERT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_SUPERVISOR_ALERT_RESET:
      return intitialstate;

    default:
      return state;
  }
};
